import { lazyWithRetry } from "~lib/lazyWithRetry.ts";

// planning group
export const LazyConstructionSiteList = lazyWithRetry(
  () =>
    import(
      "~components/Planning/ConstructionSiteList/ConstructionSiteList.tsx"
    ),
);

export const LazyConstructionSitePlanning = lazyWithRetry(
  () =>
    import(
      "~components/Planning/ConstructionSitePlanning/ConstructionSitePlanning"
    ),
);
export const LazyWorkPackageAdministration = lazyWithRetry(
  () =>
    import(
      "~components/Planning/WorkPackageAdministration/WorkPackageAdministration"
    ),
);

export const LazyTeamPlanning = lazyWithRetry(
  () => import("~components/Planning/TeamPlanning/TeamPlanning.tsx"),
);

export const LazyTeamAdministration = lazyWithRetry(
  () =>
    import("~components/Planning/TeamAdministration/TeamAdministration.tsx"),
);

export const LazyAbsences = lazyWithRetry(
  () => import("~components/Planning/Absences/Absences.tsx"),
);

export const LazyLvItemInspector = lazyWithRetry(() =>
  import("~components/Planning/LvItemInspector/LvItemInspector.tsx").then(
    (module) => ({ default: module.LvItemInspector }),
  ),
);

export const LazyPlanningsrasterPage = lazyWithRetry(
  () =>
    import("~components/Planning/Auslastungsplanung/PlanningsrasterPage.tsx"),
);

// time group
export const LazyTimeTrackingOverview = lazyWithRetry(
  () => import("~components/TimeManagement/TimeTracking/Overview/Overview.tsx"),
);

export const LazyTimeTrackingStartViewWorkPackage = lazyWithRetry(
  () =>
    import(
      "~components/TimeManagement/TimeTracking/StartView/WorkPackage/StartViewWorkPackage.tsx"
    ),
);

export const LazyTimeTrackingStartViewManagerAccount = lazyWithRetry(
  () =>
    import(
      "~components/TimeManagement/TimeTracking/StartView/ManagerAccount/StartViewManagerAccount.tsx"
    ),
);

export const LazyTimeTrackingStartViewTraining = lazyWithRetry(
  () =>
    import(
      "~components/TimeManagement/TimeTracking/StartView/Training/StartViewTraining.tsx"
    ),
);

export const LazyTimeTrackingRunningView = lazyWithRetry(
  () =>
    import(
      "~components/TimeManagement/TimeTracking/RunningView/RunningView.tsx"
    ),
);

export const LazyDailySummary = lazyWithRetry(
  () =>
    import(
      "~components/TimeManagement/TimeTracking/Overview/DailySummary/DailySummary.tsx"
    ),
);

export const LazyMyTimeEntries = lazyWithRetry(
  () => import("~components/TimeManagement/MyTimeEntries/MyTimeEntries.tsx"),
);

export const LazyMonitoring = lazyWithRetry(
  () => import("~components/TimeManagement/Monitoring/Monitoring.tsx"),
);

export const LazyTimeApproval = lazyWithRetry(
  () => import("~components/TimeManagement/TimeApproval/TimeApproval.tsx"),
);

export const LazyTimeApprovalExport = lazyWithRetry(
  () => import("~components/TimeManagement/TimeApproval/Export/Export.tsx"),
);

// resources group
export const LazyToolAdministration = lazyWithRetry(
  () =>
    import("~components/Resources/ToolAdministration/ToolAdministration.tsx"),
);

export const LazyEmployeeAdministration = lazyWithRetry(
  () =>
    import(
      "~components/Resources/EmployeeAdministration/EmployeeAdministration.tsx"
    ),
);

// health group
export const LazyInvalidConstructionSitesOverview = lazyWithRetry(
  () =>
    import(
      "~components/HealthBoard/InvalidConstructionSites/InvalidConstructionSitesOverview.tsx"
    ),
);

export const LazyInvalidProjectsOverview = lazyWithRetry(
  () =>
    import(
      "~components/HealthBoard/InvalidProjects/InvalidProjectsOverview.tsx"
    ),
);

export const LazyInvalidToolsOverview = lazyWithRetry(
  () => import("~components/HealthBoard/InvalidTools/InvalidToolsOverview.tsx"),
);

export const LazyStats = lazyWithRetry(
  () => import("~components/HealthBoard/Stats/Stats.tsx"),
);

// controlling group
export const LazyProjectsJournal = lazyWithRetry(
  () => import("~components/Controlling/ProjectsJournal/ProjectsJournal.tsx"),
);

export const LazySurcharges = lazyWithRetry(
  () => import("~components/Controlling/Surcharges/Surcharges.tsx"),
);

export const LazyWageTypes = lazyWithRetry(
  () => import("~components/Controlling/WageTypes/WageTypes"),
);

export const LazyBookedHours = lazyWithRetry(
  () => import("~components/Controlling/BookedHours/BookedHours.tsx"),
);

export const LazyKeyFigures = lazyWithRetry(
  () => import("~components/Controlling/KeyFigures/KeyFigures.tsx"),
);

export const LazyHoursEvaluation = lazyWithRetry(
  () => import("~components/Controlling/HoursEvaluation/HoursEvaluation.tsx"),
);

export const LazyProfitContributionReport = lazyWithRetry(
  () =>
    import(
      "~components/Controlling/ProfitContributionReport/ProfitContributionReport.tsx"
    ),
);

export const LazyRevenueReport = lazyWithRetry(
  () => import("~components/Controlling/RevenueReport/RevenueReport.tsx"),
);

export const LayzNominalAccountsOverview = lazyWithRetry(
  () => import("~components/Controlling/NominalAccounts/NominalAccounts.tsx"),
);

export const LazyNalDashboard = lazyWithRetry(
  () => import("~components/Controlling/NalDashboard/NalDashboard.tsx"),
);

export const LazyNalDashboardControllingEntries = lazyWithRetry(
  () =>
    import(
      "~components/Controlling/NalDashboard/Controlling/NalDashboardControllingEntries.tsx"
    ),
);

export const LazyNalDashboardControllingManager = lazyWithRetry(
  () =>
    import(
      "~components/Controlling/NalDashboard/Controlling/NalDashboardControllingManager.tsx"
    ),
);

// notifications
// Stays lazy: a static import pulls the MUI X date range picker (150 KB) into the start graph
export const LazyNotifications = lazyWithRetry(() =>
  import("~components/Notifications/Notifications.tsx").then((m) => ({
    default: m.Notifications,
  })),
);

// hidden routes
export const LazyOrganigram = lazyWithRetry(
  () => import("~components/Resources/Organigram/Organigram"),
);

export const LazyAbilities = lazyWithRetry(
  () => import("~components/App/Abilities/Abilities.tsx"),
);

export const LazyPhotoDocumentationUpload = lazyWithRetry(
  () =>
    import(
      "~components/Resources/PhotoDocumentation/PhotoUpload/PhotoUpload.tsx"
    ),
);

export const LazyPhotoDocumentationView = lazyWithRetry(
  () =>
    import(
      "~components/Resources/PhotoDocumentation/PhotoDocView/PhotoDocViewPage.tsx"
    ),
);
export const LazyPhotoDocumentationWorkPackage = lazyWithRetry(
  () =>
    import(
      "~components/Resources/PhotoDocumentation/PhotoDocView/mobile/WorkPackagePhotosPage"
    ),
);

export const LazyPhotoDocumentationManagerAccounts = lazyWithRetry(
  () =>
    import(
      "~components/Resources/PhotoDocumentation/PhotoDocView/mobile/ManagerAccountPhotosPage"
    ),
);
